import {useState} from "react";
import DoughnutChart from "./charts/DoughnutChart";
import {DashboardDoughnutChartDataMapType, DashboardSettingListElementType} from "../../interface";
import DraggableCard from "../drag/DraggableCard";

interface Props {
    title: string
    titleKeyword: string
    data: DashboardDoughnutChartDataMapType
    item: DashboardSettingListElementType
}

export default function DoughnutChartCard({title, titleKeyword, data, item}: Props) {
    const [view, setView] = useState<number>(1)

    const btnView = (i: number) => {
        setView(i)
    }

    return <DraggableCard order={item.dashboardInfoId} item={item}>
        {({dragHandleRef}) =>
            <div className="content_wrap h-295px">
                <div className="fiter_top align-items-start mb-0">
                    <h3 className="filter_heading icon2 clickable" ref={dragHandleRef}>
                        <span>{titleKeyword}</span>{title}</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-primary color2 px-0 w-60px" onClick={() => btnView(1)}>이관</button>
                        <button className="btn btn-info px-0 color2 w-60px" onClick={() => btnView(2)}>마감</button>
                    </div>
                </div>
                <div className="chart_outer_donut justify-content-center">
                    <DoughnutChart
                        title={`${titleKeyword}${title}`}
                        data={view === 1 ? (data.transferRevenueCircleGraphResList ?? []) : (data.revenueCircleGraphResList ?? [])}/>
                </div>
            </div>
        }
    </DraggableCard>
}